import React from 'react';
import AdminFilterWordProfileActions from 'actions/admin/AdminFilterWordProfileActions';
import AdminTopicEditorPageActions from 'actions/admin/AdminTopicEditorPageActions';
import GenericLink from 'components/GenericLink';
import {browserHistory} from 'react-router';

function openTopicEditor(topic) {
  browserHistory.push(`/admin/topics/${topic.filterWordId}`);
}

export function goToTopicsAdminPage() {
  browserHistory.push('/admin/topics');
}

/** Link to a topic's editor page. */
export function topicLink(topic, label = topic.word) {
  return (
    <GenericLink
      onClick={() => {
        AdminTopicEditorPageActions.setupTopicEditorForExistingTopic(topic, false);
        openTopicEditor(topic);
      }}>
      {label}
    </GenericLink>
  );
}

/**
 * Clone a topic, then go to the topic editor, editing the newly-cloned topic.
 * @param topic {NewFilterWord} topic to clone.
 */
export function cloneTopic(topic) {
  AdminFilterWordProfileActions.cloneFilterWord(topic.filterWordId).then(newTopic => {
    AdminTopicEditorPageActions.setupTopicEditorForExistingTopic(newTopic, true);
    openTopicEditor(newTopic);
  });
}

/**
 * Get the filter word profiles used by the given topic.
 *
 * @param topic {NewFilterWord} the topic.
 * @param idToProfileMap {Map<string, NewFilterWordProfile>} map of filter word profile id to
 *  profile.
 * @param profileDepartmentAndTeamUsage
 * {Map<string, Immutable.List<{department: Department, team: Team?}>>}
 * map of filter word profile id to teams and departments that use that profile.
 * @return {Immutable.Iterable<number, NewFilterWordProfile>}
 */
export function usedProfiles(topic, idToProfileMap, profileDepartmentAndTeamUsage) {
  return (
    idToProfileMap
      .valueSeq()
      .toList()
      // Filter unreferenced profiles
      .filter(profile => profileDepartmentAndTeamUsage.get(profile.filterWordProfileId))
      // Filter profiles not associated with the topic
      .filterNot(profile =>
        profile.filterWords.filter(fw => fw.filterWordId === topic.filterWordId).isEmpty()
      )
  );
}
